var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8976 27.1195C13.5567 25.3452 10.5 21.0812 10.5 16.1C10.5 9.5252 15.8253 4.19995 22.4 4.19995C28.9748 4.19995 34.3 9.5252 34.3 16.1C34.3 21.0812 31.2432 25.3453 26.9023 27.1196C31.0801 28.1016 34.7426 30.4204 37.4137 33.5999H30.6773L30.4459 33.6063C28.3015 33.7247 26.5996 35.4793 26.5996 37.6264V46.1999H2.7998C2.7998 36.9244 9.24289 29.1538 17.8976 27.1195ZM28.6867 18.9737C27.9616 21.8111 25.3707 23.8 22.3995 23.8C19.4283 23.8 16.8374 21.8111 16.1123 18.9737L19.2551 18.2C19.614 19.6225 20.911 20.6213 22.3995 20.6213C23.888 20.6213 25.1851 19.6225 25.5439 18.2L28.6867 18.9737Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4004 37.9145C29.4004 37.0781 30.0784 36.4 30.9148 36.4H50.2859C51.1224 36.4 51.8004 37.0781 51.8004 37.9145V49.2372C51.8004 50.0736 51.1223 50.7516 50.2859 50.7516H45.1182C44.4363 50.7582 42.6219 52.0593 41.5109 52.9072C40.9844 53.3091 40.24 53.2804 39.7337 52.8534C38.7282 52.0053 37.0812 50.7581 36.0848 50.7516H30.9148C30.0784 50.7516 29.4004 50.0736 29.4004 49.2372V37.9145ZM35.3231 45.011C36.1558 45.011 36.8308 44.3684 36.8308 43.5758C36.8308 42.7832 36.1558 42.1406 35.3231 42.1406C34.4904 42.1406 33.8154 42.7832 33.8154 43.5758C33.8154 44.3684 34.4904 45.011 35.3231 45.011ZM40.6005 45.011C41.4331 45.011 42.1082 44.3684 42.1082 43.5758C42.1082 42.7832 41.4331 42.1406 40.6005 42.1406C39.7678 42.1406 39.0928 42.7832 39.0928 43.5758C39.0928 44.3684 39.7678 45.011 40.6005 45.011ZM47.3845 43.5758C47.3845 44.3684 46.7095 45.011 45.8768 45.011C45.0442 45.011 44.3691 44.3684 44.3691 43.5758C44.3691 42.7832 45.0442 42.1406 45.8768 42.1406C46.7095 42.1406 47.3845 42.7832 47.3845 43.5758Z",
    fill: "#6B7CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.604fb7dd9c9f03c155d823ad783b251a.svg";
export { ForwardRef as ReactComponent };